import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { CheckCircle, Clock } from 'lucide-react';
import { AdminPagination } from './AdminPagination';
import { formatDateFor } from './adminUtils';

export const AdminAssessmentsTab = ({
  assessments, page, setPage, pageSize,
  statusFilter, setStatusFilter, tierFilter, setTierFilter, language
}) => {
  const tr = language === 'tr';
  const formatDate = formatDateFor(language);
  return (
    <Card className="bg-slate-900/50 border-slate-800" data-testid="admin-assessments-tab">
      <CardHeader>
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div>
            <CardTitle className="text-white">{tr ? 'Değerlendirme Listesi' : 'Assessment List'}</CardTitle>
            <CardDescription className="text-slate-400">
              {tr ? `Toplam ${assessments.total} değerlendirme` : `Total ${assessments.total} assessments`}
            </CardDescription>
          </div>
          <div className="flex space-x-2">
            <Select value={statusFilter} onValueChange={setStatusFilter}>
              <SelectTrigger className="w-36 bg-slate-800 border-slate-700 text-white text-xs h-8" data-testid="assessment-status-filter">
                <SelectValue placeholder={tr ? 'Durum' : 'Status'} />
              </SelectTrigger>
              <SelectContent className="bg-slate-800 border-slate-700">
                <SelectItem value="all" className="text-white text-xs">{tr ? 'Tümü' : 'All'}</SelectItem>
                <SelectItem value="in_progress" className="text-white text-xs">{tr ? 'Devam Eden' : 'In Progress'}</SelectItem>
                <SelectItem value="completed" className="text-white text-xs">{tr ? 'Tamamlandı' : 'Completed'}</SelectItem>
              </SelectContent>
            </Select>
            <Select value={tierFilter} onValueChange={setTierFilter}>
              <SelectTrigger className="w-36 bg-slate-800 border-slate-700 text-white text-xs h-8" data-testid="assessment-tier-filter">
                <SelectValue placeholder={tr ? 'Paket' : 'Tier'} />
              </SelectTrigger>
              <SelectContent className="bg-slate-800 border-slate-700">
                <SelectItem value="all" className="text-white text-xs">{tr ? 'Tümü' : 'All'}</SelectItem>
                <SelectItem value="executive_scan" className="text-white text-xs">Executive</SelectItem>
                <SelectItem value="operational" className="text-white text-xs">Operational</SelectItem>
                <SelectItem value="enterprise" className="text-white text-xs">Enterprise</SelectItem>
                <SelectItem value="strategic" className="text-white text-xs">Strategic</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow className="border-slate-700">
              <TableHead className="text-slate-400">{tr ? 'Şirket' : 'Company'}</TableHead>
              <TableHead className="text-slate-400">{tr ? 'Kullanıcı' : 'User'}</TableHead>
              <TableHead className="text-slate-400">{tr ? 'Paket' : 'Tier'}</TableHead>
              <TableHead className="text-slate-400">{tr ? 'Durum' : 'Status'}</TableHead>
              <TableHead className="text-slate-400">GDMII</TableHead>
              <TableHead className="text-slate-400">{tr ? 'Tarih' : 'Date'}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {assessments.assessments.map((a) => (
              <TableRow key={a.id} className="border-slate-700">
                <TableCell className="text-white text-sm">{a.company_name}</TableCell>
                <TableCell className="text-slate-300 text-sm">{a.user_email}</TableCell>
                <TableCell>
                  <span className={`px-2 py-0.5 text-xs rounded-full ${
                    a.assessment_tier === 'enterprise' ? 'bg-purple-500/20 text-purple-400' :
                    a.assessment_tier === 'strategic' ? 'bg-amber-500/20 text-amber-400' :
                    a.assessment_tier === 'operational' ? 'bg-blue-500/20 text-blue-400' :
                    'bg-slate-500/20 text-slate-400'
                  }`}>
                    {a.assessment_tier?.replace('_', ' ') || 'N/A'}
                  </span>
                </TableCell>
                <TableCell>
                  <span className={`flex items-center space-x-1 text-xs ${a.status === 'completed' ? 'text-emerald-400' : 'text-amber-400'}`}>
                    {a.status === 'completed' ? <CheckCircle className="h-3 w-3" /> : <Clock className="h-3 w-3" />}
                    <span>{a.status === 'completed' ? (tr ? 'Tamamlandı' : 'Done') : (tr ? 'Devam' : 'Progress')}</span>
                  </span>
                </TableCell>
                <TableCell className="text-white font-medium text-sm">{a.gdmii_score?.toFixed(1) || '-'}</TableCell>
                <TableCell className="text-slate-400 text-xs">{formatDate(a.started_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <AdminPagination page={page} setPage={setPage} total={assessments.total} pageSize={pageSize} testId="assessments-pagination" />
      </CardContent>
    </Card>
  );
};
